export interface XuanxueStory {
  id: string;
  title: string;
  file: string;
}

export const xuanxueStoriesData: XuanxueStory[] = [
  { id: 'top-actress', title: '顶级女星的豪宅神龛里，供的不是佛，是一个活生生的女孩', file: '/stories/顶级女星.md' },
  { id: 'rich-woman', title: '富婆哭着说老公加入邪教被“夺舍”了，其实他是去当狗', file: '/stories/富婆哭着.md' },
  { id: 'clone-dog', title: '他花百万克隆爱犬，结果接回来一个索命的仇家', file: '/stories/百万克隆恶犬.md' },
  { id: 'billionaire-shixiong', title: '我那个身家过亿的师兄说他撞邪了，阴兵抢走了他三千万美金', file: '/stories/我那个身价过亿的师兄.md' },
  { id: 'last-shift', title: '最后一班岗：拆不掉的小区', file: '/stories/最后一班岗.md' },
  { id: 'stomp-foot', title: '他剁了一脚，就让竞争对手家破人亡', file: '/stories/他跺一脚.md' },
  { id: 'massage-shop', title: '按摩店惊魂：凌晨三点，谁在掐技师的脖子？', file: '/stories/按摩店惊魂.md' },
];
